// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LogoFull from 'assets/images/logo-full.svg';
// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 , flexDirection: 'column' }}>
      <Box
        sx={{
          width: 100,
          height: 50,
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `0 2px 8px ${theme.vars?.palette?.primary?.light || theme.palette.primary.light}40`,
          backgroundImage: `url(${LogoFull})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
      </Box>
      <Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: theme.vars?.palette?.text?.primary || theme.palette.text.primary,
            lineHeight: 1,
            fontSize: '1rem'
          }}
        >
         Admin Panel
        </Typography>
      </Box>
    </Box>
  );
}